//Iconos material-ui
import {
  NoteAdd,
  FindInPage,
  Description,
  Public,
  Assignment,
  PieChart,
  ListAlt,
  AssignmentReturn,
  LocalAtm,
  SupervisorAccount,
  Business,
  Timeline,
  Category,
  LinearScale,
} from "@material-ui/icons";
import {
  FactCheck,
  PersonSearch,
  PriceChange,
  RequestQuote,
  AutoAwesomeMosaic,
  Plagiarism,
  Warehouse,
  Groups2,
  CurrencyExchange,
} from "@mui/icons-material";
import OndemandVideoIcon from "@mui/icons-material/OndemandVideo";
import HelpCenterIcon from "@mui/icons-material/HelpCenter";

import * as style from "./style";
import { Icon } from "@material-ui/core";


export const arrStorage = (roles = [], userId) => {
  const arr = [
    {
      id: 106101,
      name: "Consultar Documentos Enviados",
      ruta: "SupplierInvoices",
      restriccion: roles?.ROLE_BUYS,
      icono: (
        <Icon style={style.styleFavorite("#DF2C52", "#ED2A2A", "#C51A1A")}>
          <Description style={style.styleFigure} />
        </Icon>
      ),
      forStorage: localStorage.getItem(`${userId}SupplierInvoices`),
      parent: "COMPRAS",
      module_restriccion: [roles?.ROLE_BUYS, roles?.ROLE_EXPENSE],
    },

    {
      id: 106102,
      name: "Enviar Documentos",
      ruta: "validador",
      restriccion: roles?.ROLE_BUYS,
      icono: (
        <Icon style={style.styleFavorite("#DF2C52", "#ED2A2A", "#C51A1A")}>
          <AssignmentReturn style={style.styleFigure} />
        </Icon>
      ),
      forStorage: localStorage.getItem(`${userId}validador`),
      parent: "COMPRAS",
      module_restriccion: [roles?.ROLE_BUYS, roles?.ROLE_EXPENSE],
    },
    {
      id: 1061021,
      name: "Consultar Proveedores",
      ruta: "SUPPLIER_TS",
      restriccion: roles?.ROLE_BUYS,
      icono: (
        <Icon style={style.styleFavorite("#DF2C52", "#ED2A2A", "#C51A1A")}>
          <AssignmentReturn style={style.styleFigure} />
        </Icon>
      ),
      forStorage: localStorage.getItem(`${userId}supplier_v2`),
      parent: "COMPRAS",
      module_restriccion: [roles?.ROLE_BUYS, roles?.ROLE_EXPENSE],
    },
    {
      id: 106103,
      name: "Gastos no Deducibles",
      ruta: "expenses_v2",
      restriccion: roles?.ROLE_BUYS,
      icono: (
        <Icon style={style.styleFavorite("#DF2C52", "#ED2A2A", "#C51A1A")}>
          <PriceChange style={style.styleFigure} />
        </Icon>
      ),
      forStorage: localStorage.getItem(`${userId}expenses_v2`),
      parent: "COMPRAS",
      module_restriccion: [roles?.ROLE_BUYS, roles?.ROLE_EXPENSE],
    },
    {
      id: 106104,
      name: "Gastos del Extranjero",
      ruta: "EXPENSES_FOREING_V2",
      restriccion: roles?.ROLE_BUYS,
      icono: (
        <Icon style={style.styleFavorite("#DF2C52", "#ED2A2A", "#C51A1A")}>
          <Public style={style.styleFigure} />
        </Icon>
      ),
      forStorage: localStorage.getItem(`${userId}EXPENSES_FOREING_V2`),
      parent: "COMPRAS",
      module_restriccion: [roles?.ROLE_BUYS, roles?.ROLE_EXPENSE],
    },
    {
      id: 106105,
      name: "Reporte de Gastos",
      ruta: "expense_report",
      restriccion: roles?.ROLE_BUYS,
      icono: (
        <Icon style={style.styleFavorite("#DF2C52", "#ED2A2A", "#C51A1A")}>
          <Assignment style={style.styleFigure} />
        </Icon>
      ),
      forStorage: localStorage.getItem(`${userId}expense_report`),
      parent: "COMPRAS",
      module_restriccion: [roles?.ROLE_BUYS, roles?.ROLE_EXPENSE],
    },
    {
      id: 106106,
      name: "Reporte de Gastos Agrupados",
      ruta: "expense_group",
      restriccion: roles?.ROLE_BUYS,
      icono: (
        <Icon style={style.styleFavorite("#DF2C52", "#ED2A2A", "#C51A1A")}>
          <PieChart style={style.styleFigure} />
        </Icon>
      ),
      forStorage: localStorage.getItem(`${userId}expense_group`),
      parent: "COMPRAS",
      module_restriccion: [roles?.ROLE_BUYS, roles?.ROLE_EXPENSE],
    },
    {
      id: 106107,
      name: "Pólizas",
      ruta: "policy_v2",
      restriccion: roles?.ROLE_POLICY,
      icono: (
        <Icon style={style.styleFavorite("#DF2C52", "#ED2A2A", "#C51A1A")}>
          <ListAlt style={style.styleFigure} />
        </Icon>
      ),
      forStorage: localStorage.getItem(`${userId}policy_v2`),
      parent: "COMPRAS",
      module_restriccion: [roles?.ROLE_BUYS, roles?.ROLE_EXPENSE],
    },
    {
      id: 106108,
      name: "Catálogo de Gastos",
      ruta: "catalog_expense_concept_v2",
      restriccion: roles?.ROLE_EXPENSE_ADMINISTRATIVOS,
      icono: (
        <Icon style={style.styleFavorite("#DF2C52", "#ED2A2A", "#C51A1A")}>
          <AutoAwesomeMosaic style={style.styleFigure} />
        </Icon>
      ),
      forStorage: localStorage.getItem(`${userId}catalog_expense_concept_v2`),
      parent: "COMPRAS",
      module_restriccion: [roles?.ROLE_BUYS, roles?.ROLE_EXPENSE],
    },
    {
      id: 106109,
      name: "Regla de Gastos",
      ruta: "consult_rules_sending_expenses_v2",
      restriccion: roles?.ROLE_EXPENSE_ADMINISTRATIVOS,
      icono: (
        <Icon style={style.styleFavorite("#DF2C52", "#ED2A2A", "#C51A1A")}>
          <LocalAtm style={style.styleFigure} />
        </Icon>
      ),
      forStorage: localStorage.getItem(
        `${userId}consult_rules_sending_expenses_v2`
      ),
      parent: "COMPRAS",
      module_restriccion: [roles?.ROLE_BUYS, roles?.ROLE_EXPENSE],
    },

    {
      id: 106110,
      name: "CONSULTAR ORDENES DE COMPRAS",
      ruta: "PURCHASE_ORDERS",
      restriccion: roles?.ROLE_BUYS,
      icono: (
        <Icon style={style.styleFavorite("#DF2C52", "#ED2A2A", "#C51A1A")}>
          <SupervisorAccount style={style.styleFigure} />
        </Icon>
      ),
    
      forStorage: localStorage.getItem(`${userId}PURCHASE_ORDERS`),

      parent: "COMPRAS",
      module_restriccion: [roles?.ROLE_BUYS, roles?.ROLE_EXPENSE],
    },

    //FACTURAS

    {
      id: 107102,
      name: "Consultar Conceptos",
      ruta: "consult_concept_v2",
      restriccion: roles?.ROLE_INVOICING,
      icono: (
        <Icon style={style.styleFavorite("#FF4003", "#FF6433", "#CD3200")}>
          <FindInPage style={style.styleFigure} />
        </Icon>
      ),
      forStorage: localStorage.getItem(`${userId}consult_concept_v2`),
      parent: "FACTURAS",
      module_restriccion: [
        roles?.ROLE_INVOICING,
        roles?.ROLE_CARTA_PORTE,
        roles?.ROLE_COMPLEMENTO_PAGO,
      ],
    },
    {
      id: 107103,
      name: "Consultar Facturas",
      ruta: "invoice",
      restriccion: roles?.ROLE_INVOICING,
      icono: (
        <Icon style={style.styleFavorite("#FF4003", "#FF6433", "#CD3200")}>
          <FactCheck style={style.styleFigure} />
        </Icon>
      ),
      forStorage: localStorage.getItem(`${userId}invoice_v2`),
      parent: "FACTURAS",
      module_restriccion: [
        roles?.ROLE_INVOICING,
        roles?.ROLE_CARTA_PORTE,
        roles?.ROLE_COMPLEMENTO_PAGO,
      ],
    },
    {
      id: 107104,
      name: "Consultar Facturas PPD",
      ruta: "FacturasPPD_v2",
      restriccion: roles?.ROLE_INVOICING,
      icono: (
        <Icon style={style.styleFavorite("#FF4003", "#FF6433", "#CD3200")}>
          <Plagiarism style={style.styleFigure} />
        </Icon>
      ),
      forStorage: localStorage.getItem(`${userId}FacturasPPD_v2`),
      parent: "FACTURAS",
      module_restriccion: [
        roles?.ROLE_INVOICING,
        roles?.ROLE_CARTA_PORTE,
        roles?.ROLE_COMPLEMENTO_PAGO,
      ],
    },

    {
      id: 107105,
      name: "Consultar Impuestos",
      ruta: "consult_taxes_v2",
      restriccion: roles?.ROLE_INVOICING,
      icono: (
        <Icon style={style.styleFavorite("#FF4003", "#FF6433", "#CD3200")}>
          <CurrencyExchange style={style.styleFigure} />
        </Icon>
      ),
      forStorage: localStorage.getItem(`${userId}consult_taxes_v2`),
      parent: "FACTURAS",
      module_restriccion: [
        roles?.ROLE_INVOICING,
        roles?.ROLE_CARTA_PORTE,
        roles?.ROLE_COMPLEMENTO_PAGO,
      ],
    },


    {
      id: 107107,
      name: "Realizar Factura",
      ruta: "generate_invoice",
      restriccion: roles?.ROLE_INVOICING,
      icono: (
        <Icon style={style.styleFavorite("#FF4003", "#FF6433", "#CD3200")}>
          <NoteAdd style={style.styleFigure} />
        </Icon>
      ),
      forStorage: localStorage.getItem(`${userId}GenerarFactura`),
      parent: "FACTURAS",
      module_restriccion: [
        roles?.ROLE_INVOICING,
        roles?.ROLE_CARTA_PORTE,
        roles?.ROLE_COMPLEMENTO_PAGO,
      ],
    },
    {
      id: 107108,
      name: "Realizar Complemento de Pago",
      ruta: "invoice_paid",
      restriccion: roles?.ROLE_COMPLEMENTO_PAGO,
      icono: (
        <Icon style={style.styleFavorite("#FF4003", "#FF6433", "#CD3200")}>
          <RequestQuote style={style.styleFigure} />
        </Icon>
      ),
      forStorage: localStorage.getItem(`${userId}pago`),
      parent: "FACTURAS",
      module_restriccion: [
        roles?.ROLE_INVOICING,
        roles?.ROLE_CARTA_PORTE,
        roles?.ROLE_COMPLEMENTO_PAGO,
      ],
    },

    //SOCIO DE NEGOCIOS

    {
      id: 108105,
      name: "Consultar Socio de Negocios",
      ruta: "BUSSINES_PARTNER_TS",
      restriccion: roles?.ROLE_BUSINESS_PARTNER_BUSINESS_PARTNER,
      icono: (
        <Icon style={style.styleFavorite("#373B44", "#9B23A3", "#F3904F")}>
          <PersonSearch style={style.styleFigure} />
        </Icon>
      ),
      forStorage: localStorage.getItem(`${userId}bussines_partnert_v2`),
      parent: "SOCIO DE NEGOCIOS",
      module_restriccion: [roles?.ROLE_BUSINESS_PARTNER],
    },
    //CONFIGURACION
    {
      id: 110101,
      name: "Almacén",
      ruta: "TableWarehouse",
      restriccion: roles?.ROLE_CONFIGURATION,
      icono: (
        <Icon style={style.styleFavorite("#535962", "#818181", "#393E47")}>
          <Warehouse style={style.styleFigure} />
        </Icon>
      ),
      forStorage: localStorage.getItem(`${userId}TableWarehouse`),
      parent: "CONFIGURACIÓN",
      module_restriccion: [roles?.ROLE_CONFIGURATION],
    },
    {
      id: 110102,
      name: "Empresa",
      ruta: "edit_company",
      restriccion: roles?.ROLE_CONFIGURATION,
      icono: (
        <Icon style={style.styleFavorite("#535962", "#818181", "#393E47")}>
          <Business style={style.styleFigure} />
        </Icon>
      ),
      forStorage: localStorage.getItem(`${userId}edit_company`),
      parent: "CONFIGURACIÓN",
      module_restriccion: [roles?.ROLE_CONFIGURATION, roles?.ROLE_ADMIN],
    },
    {
      id: 110103,
      name: "Roles",
      ruta: "consult_roles",
      restriccion: roles?.ROLE_ADMIN,
      icono: (
        <Icon style={style.styleFavorite("#535962", "#818181", "#393E47")}>
          <Category style={style.styleFigure} />
        </Icon>
      ),
      forStorage: localStorage.getItem(`${userId}Consult_route`),
      parent: "CONFIGURACIÓN",
      module_restriccion: [roles?.ROLE_CONFIGURATION, roles?.ROLE_ADMIN],
    },
    {
      id: 110104,
      name: "Rutas",
      ruta: "Consult_route",
      restriccion: roles?.ROLE_CONFIGURATION,
      icono: (
        <Icon style={style.styleFavorite("#535962", "#818181", "#393E47")}>
          <Timeline style={style.styleFigure} />
        </Icon>
      ),
      forStorage: localStorage.getItem(`${userId}Consult_route`),
      parent: "CONFIGURACIÓN",
      module_restriccion: [roles?.ROLE_CONFIGURATION, roles?.ROLE_ADMIN],
    },
    {
      id: 110105,
      name: "Usuarios",
      ruta: "consult_users",
      restriccion: roles?.ROLE_CONFIGURATION,
      icono: (
        <Icon style={style.styleFavorite("#535962", "#818181", "#393E47")}>
          <Groups2 style={style.styleFigure} />
        </Icon>
      ),
      forStorage: localStorage.getItem(`${userId}consult_users`),
      parent: "CONFIGURACIÓN",
      module_restriccion: [roles?.ROLE_CONFIGURATION, roles?.ROLE_ADMIN],
    },
    // SOPORTE
    {
      id: 111101,
      name: "Capacitación",
      ruta: "consult_capacitation",
      restriccion: "",
      icono: (
        <Icon style={style.styleFavorite("#1695CD", "#2863CB", "#1337DB")}>
          <OndemandVideoIcon style={style.styleFigure} />
        </Icon>
      ),
      forStorage: localStorage.getItem(`${userId}consult_capacitation`),
      parent: "SOPORTE",
      module_restriccion: [roles?.ROLE_USERS],
    },
    {
      id: 111102,
      name: "Centro de ayuda",
      ruta: "help_center_v2",
      restriccion: "",
      icono: (
        <Icon style={style.styleFavorite("#1695CD", "#2863CB", "#1337DB")}>
          <HelpCenterIcon style={style.styleFigure} />
        </Icon>
      ),
      forStorage: localStorage.getItem(`${userId}help_center_v2`),
      parent: "SOPORTE",
      module_restriccion: [roles?.ROLE_USERS],
    },
  ];
  return arr;
};
